export const _resultsPerPage = 10;
export const _mobileResultsPerPage = 12;
